module.exports = __webpack_public_path__ + "img/logo12.da2e4206.png";